<template>
  <!-- 充电订单管理 -->
  <div class="billOperationRecord public_Spacing">
    <div class="pulbic_oparetionBlock" style="margin-bottom: 12px;">
      <el-form
        :inline="true"
        class="demo-form-inline"
        size="small"
        label-position="left"
      >
        <el-form-item label="归属电站" class="searchfrom_item">
          <el-select clearable v-model="ORMTB601ID" placeholder="请选择">
            <el-option
              v-for="item in ormtb601idList"
              :key="item.ormtb601id"
              :label="item.ormtb601ca00"
              :value="item.ormtb601id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="桩名称" class="searchfrom_item">
          <el-input v-model="ORMTB602CA03" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="订单编码" class="searchfrom_item">
          <el-input v-model="ORMTB607CA14" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="车牌号" class="searchfrom_item">
          <el-input v-model="ORMTB607CA12" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="订单状态" class="searchfrom_item">
          <el-select v-model="ORMTB607CA10" placeholder="请选择">
            <el-option label="创建" :value="0"> </el-option>
            <el-option label="充电中" :value="1"> </el-option>
            <el-option label="已结束" :value="2"> </el-option>
            <el-option label="预约中" :value="3"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户账号" class="searchfrom_item">
          <el-select
            v-model="ORMTB410ID"
            placeholder="请选择"
            filterable
            clearable
          >
            <el-option
              v-for="(item,index) in customerOptions"
              :key="index"
              :label="item.ORMTB410CA00"
              :value="item.ORMTB410ID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" class="searchfrom_item">
          <el-date-picker
            v-model="dateTime1"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="search_btns">
          <el-button
            style="margin-right:12px"
            id="查询"
            v-shiroHiden="solelist"
            size="medium"
            type="primary"
            @click="queryClick"
            >搜索</el-button
          >
          <el-button
            style="margin-right:8px"
            size="medium"
            type="success"
            id="查询"
            v-shiroHiden="solelist"
            @click="serchReset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="billOperationRecord-table pulbic_table_container">
      <div class="top_title">
        <div class="title">订单列表</div>
        <div class="right_btns">
          <div
            class="right_btns_item"
            v-for="(item, index) in statusList"
            :key="index"
            :style="{
              background: getTypecolor(index + 1).b,
              color: getTypecolor(index + 1).c,
              borderColor: getTypecolor(index + 1).c,
            }"
          >
            {{ item.label + ':' + item.value }}
          </div>
          <el-button
            class="dc_btn"
            :loading="loadingBut"
            v-shiroHiden="solelist"
            @click="exports"
            id="导出"
            ><i class="iconfont icon-daochu"></i>导出<span
              v-if="confirmTxt > 0"
              >{{ confirmTxt }}</span
            ></el-button
          >
          <!-- <div class="dc_btn" type="primary" @click="exports">
            <i class="el-icon-upload2 el-icon--right"></i>导出
          </div> -->
        </div>
      </div>
      <el-table
        tooltip-effect="dark"
        :data="tableData"
        style="width: 100%;"
        :default-sort="{ prop: 'waterNum', order: 'descending' }"
        :header-cell-style="{
          color: 'rgba(255,255,255,1)',
          background: '#199FFF',
          'font-weight': 'bold',
        }"
        :header-cell-class-name="'custom-header'"
        class="public_tableColumn"
        @selection-change="handleSelectionChange"
      >
        <!--<el-table-column prop="ORMTB440CA00" width="130" fixed="left" label="派单编号">-->
        <!--</el-table-column>-->

        <el-table-column
          prop="ORMTB607CA14"
          show-overflow-tooltip
          label="订单编号"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="custom_tooltip"
              effect="dark"
              :content="scope.row.ORMTB607CA14"
              placement="top"
            >
              <p>
                <span class="name_length">{{ scope.row.ORMTB607CA14 }}</span>
              </p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="ORMTB601CA00"
          show-overflow-tooltip
          label="归属站点"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="custom_tooltip"
              effect="dark"
              :content="scope.row.ORMTB601CA00"
              placement="top"
            >
              <p>
                <span class="name_length">{{ scope.row.ORMTB601CA00 }}</span>
              </p>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column prop="ORMTB410CA00" label="用户账号"></el-table-column>
        <el-table-column prop="ORMTB607CA10" label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.ORMTB607CA10 == 0">创建 </span>
            <span v-else-if="scope.row.ORMTB607CA10 == 1">充电中</span>
            <span v-else-if="scope.row.ORMTB607CA10 == 3">预约中</span>
            <span v-else>已结束</span>
          </template>
        </el-table-column>
        <el-table-column prop="ORMTB602CA03" label="桩名称"></el-table-column>
        <el-table-column prop="ORMTB603CA07" label="枪号"></el-table-column>
        <el-table-column prop="ORMTB607CA12" label="车牌号"></el-table-column>
        <el-table-column
          prop="ORMTB607CA06"
          label="订单金额(元)"
        ></el-table-column>
        <el-table-column prop="ORMTB607CA07" label="充电电量">
          <template slot-scope="scoped">
            <span>{{ scoped.row.ORMTB607CA07 || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ORMTB607CA08" label="充电时长"></el-table-column>
        <el-table-column prop="ORMTB607CA01" label="创建时间"></el-table-column>
        <el-table-column prop="ORMTB607CA03" label="结算时间"></el-table-column>
        <!-- <el-table-column
          v-for="(item, index) in tableHeadList"
          :width="item.width"
          :prop="item.prop"
          :label="item.label"
          :key="index"
        >
        </el-table-column> -->

        <el-table-column
          v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'"
          label="操作"
          fixed="right"
          width="160"
        >
          <template slot-scope="scope">
            <el-button
              class="public_icon_xiangqing public_icon_width  public_icon_margin"
              type="primary"
              size="small"
              id="详情"
              v-shiroHiden="solelist"
              @click="DetailsClick(scope.row)"
              >详情</el-button
            >
            <el-button
              v-if="scope.row.ORMTB607CA10 == 0"
              class="public_icon_zuofei public_icon_width  public_icon_margin"
              type="primary"
              size="small"
              id="退款"
              @click="elecOrderRefund(scope.row)"
              >退款</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pulbic_pagesize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limitMo"
          layout="total,sizes, prev, pager, next, jumper"
          :total="pagingPageMo"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import customerSearchMixin from '@/mixins/customerSearchMixin'
export default {
  mixins: [customerSearchMixin],
  components: {
    Map,
  },
  data() {
    return {
      ORMTB601ID: '',
      ORMTB602CA00: '', //桩编号
      ORMTB602CA03: '', //桩名称
      ORMTB607CA12: '', //车牌号
      ORMTB607CA14: '',
      ORMTB607CA10: '',
      ORMTB410ID: '',
      startTime: '',
      endTime: '',
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      ormtb601idList: [],
      dateTime1: [],
      statusList: [],
      lx: '',
      zx: '',
      customerOptions: [
        // {
        //   ORMTB410ID: '',
        //   ORMTB410CA00: '全部',
        // },
      ],
      confirmTxt: 0,
      loadingBut: false,
      paramFrom: {
        ormtb601id: '',
        ormtb602ca00: '',
        ormtb602ca0: '',
        ormtb602ca03: '',
        ormtb602ca04: 100,
        ormtb602ca05: 1,
        ormtb602ca06: '',
        ormtb602ca09: 1,
        ormtb602ca10: '',
      },
      tableData: [],
      ormtb608idList: [], //费率列表
      cdsUpdateShow: false,
      uobj: this.$store.state.uobj, //登陆缓存--用户信息

      //dialog

      pagingPageMo: 0, //分页--数据列表共有的条数
      currentPage: 1, //设置当前页默认为1
      // 详情
      detailsList: '', //详情列表

      // 历史缓存
      currentUrl: this.$route.path,
      historyInfo: '',
      solelist: [], //权限列表

      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const start = new Date()
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            },
          },
          // 【新增】“今日至今”快捷选项
          {
            text: '今日至此刻',
            onClick(picker) {
              const end = new Date() // 结束时间为当前时间
              const start = new Date() // 开始时间也先获取当前时间
              start.setHours(0, 0, 0, 0) // 再将开始时间设置为今天的零点
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              end.setTime(end.getTime() - 3600 * 1000 * 24)
              start.setHours(0, 0, 0, 0)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '当月',
            onClick(picker) {
              const now = new Date()
              const start = new Date(now.getFullYear(), now.getMonth(), 1)
              const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上月',
            onClick(picker) {
              const now = new Date()
              const start = new Date(now.getFullYear(), now.getMonth() - 1, 1)
              const end = new Date(now.getFullYear(), now.getMonth(), 0)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },

  // 存储数据
  beforeDestroy() {
    var obj = {
      ORMTB601ID: this.ORMTB601ID,
      ORMTB602CA00: this.ORMTB602CA00,
      ORMTB607CA14: this.ORMTB607CA14,
      ORMTB607CA10: this.ORMTB607CA10,
      ORMTB410ID: this.ORMTB410ID,
      startTime: this.dateTime1[0],
      endTime: this.dateTime1[1],
      pageMo: this.pageMo,
      limitMo: this.limitMo,
    }
    sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
  },

  // watch: {
  //   weightOpt: {
  //     handler(val) {
  //       if (
  //         (val.tare || val.tare === 0) &&
  //         (val.gross || val.gross === 0) &&
  //         (val.price || val.price === 0)
  //       ) {
  //         let tare = parseFloat(val.tare);
  //         let gross = parseFloat(val.gross);
  //         this.detailsList.ORMTB440CC04 = (tare - gross).toFixed(2);
  //         if (this.detailsList.ORMTB440CC04) {
  //           debounce(this.getSettlementAmount, 500);
  //         }
  //       } else {
  //         this.detailsList.ORMTB440CC04 = "";
  //         this.detailsList.ORMTB440CC06 = "";
  //       }
  //     },
  //     deep: true,
  //   },
  // },
  created() {
    var list = ''
    list = this.$store.state.solelist

    var path = this.$route.path

    // 赋值，缓存销毁
    this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
    console.log('lishi')
    this.userobj = this.$store.state.uobj
    this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
    console.log('list', this.solelist)
    sessionStorage.removeItem(this.currentUrl)
    if (this.historyInfo != null && this.historyInfo != '') {
      this.init()
    }
    this.ORMTB602CA00 = this.$route.query.pileCode
    this.getormtb601idList()
    // console.log(this.historyInfo)
    // else {
    // 	this.getNowDay();
    // }
  },
  mounted() {
    this.pageList()
    this.enterprise0ptions()
  },

  methods: {
    /// 客户--查询
    enterprise0ptions() {
      var postData = {}
      // console.log(this.uobj)
      // if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
      //   postData = {
      //     ORMTB400ID: this.uobj.ormtb410.ORMTB410ID, //一级企业id
      //   }
      // }
      // if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
      //   postData = {
      //     ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级企业id
      //   }
      // }

      // var List = [
      //   {
      //     ORMTB410ID: '',
      //     ORMTB410CA00: '全部',
      //   },
      // ]
      var url = '/orm/ormtb607/select410List'
      this.axios.post(url, postData).then(res => {
        if (res.data.code == 200) {
          // 客户
          this.customerOptions = res.data.data
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    //退款
    elecOrderRefund(row) {
      const $this = this
      this.$confirm('此操作将会退款该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let url = 'orm/ormtb607/dealException607'
        let data = {
          ORMTB607ID: row.ORMTB607ID,
        }
        this.axios.post(url, data).then(res => {
          if (res.data.code == 200) {
            $this.$message({
              type: 'success',
              message: '退款成功!',
            })
            $this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
      })
    },
    //导出
    exports() {
      this.$confirm('此操作将会导出该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let startTime = this.dateTime1[0] || '' //开始时间
        let endTime = this.dateTime1[1] || '' //结束时间
        let ORMTB601ID = this.ORMTB601ID || '' //站点Id
        let ORMTB602CA00 = this.ORMTB602CA00 || '' //桩编号
        let ORMTB607CA14 = this.ORMTB607CA14 || '' //订单编号
        let ORMTB607CA10 = this.ORMTB607CA10 || '' //订单状态
        let ORMTB410ID = this.ORMTB410ID || '' //客户ID
        let url =
          this.axios.defaults.baseURL +
          'exc/toExcel/ormtb607toExcel?startTime=' +
          startTime +
          '&endTime=' +
          endTime +
          '&ORMTB601ID=' +
          ORMTB601ID +
          '&ORMTB602CA00=' +
          ORMTB602CA00 +
          '&ORMTB607CA14=' +
          ORMTB607CA14 +
          '&ORMTB607CA10=' +
          ORMTB607CA10 +
          '&ORMTB410ID=' +
          ORMTB410ID
        window.location.href = url
        this.loadingBut = true
        var timer = null //倒计时
        this.confirmTxt = 30 - 1
        timer = setInterval(() => {
          if (this.confirmTxt === 0) {
            this.confirmTxt = ''
            this.loadingBut = false
            clearInterval(timer)
          } else {
            this.confirmTxt--
          }
        }, 1000)
        // this.axios.get(url).then(res => {
        //   if (res.data.code == 200) {
        //     this.$message({
        //       type: 'success',
        //       message: '导出成功!',
        //     })
        //   }
        // })
      })
    },
    //重置
    serchReset() {
      this.ORMTB601ID = ''
      this.ORMTB602CA00 = ''
      this.ORMTB607CA14 = ''
      this.ORMTB607CA10 = ''
      this.ORMTB410ID = ''
      this.startTime = ''
      this.endTime = ''
      this.dateTime1 = []
      this.pageMo = 1
      this.pageList()
    },
    typeChange(val) {
      console.log('val', val)
    },
    getTypecolor(num) {
      switch (num) {
        case 1:
          return {
            c: '#15C350',
            b: '#C8FFDB',
          }
        case 2:
          return {
            c: '#FFB100',
            b: '#FFEBBF',
          }
        case 3:
          return {
            c: '#02C1FF',
            b: '#BBEEFF',
          }
        case 4:
          return {
            c: '#0778F6',
            b: '#9CCBFF',
          }
        case 5:
          return {
            c: '#31D8D5',
            b: '#9AFFFD',
          }
        default:
          return {
            c: '#FFBE16',
            b: '#FFF8E6',
          }
      }
    },

    //获取站点
    getormtb601idList() {
      var url = '/orm/ormtb601/selecAll601'
      this.axios.post(url).then(res => {
        if (res.data.code == 200) {
          this.ormtb601idList = res.data.data
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    handleSelectionChange(val) {
      this.detIds = val
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.limitMo = val
      this.pageList()
    },

    //初始化数据
    init() {
      this.ormtb601id = this.historyInfo.ormtb601id
      this.ormtb602ca00 = this.historyInfo.ormtb602ca00
      this.ormtb602ca03 = this.historyInfo.ormtb602ca03
      this.ormtb602ca06 = this.historyInfo.ormtb602ca06
      this.startTime = this.historyInfo.startTime
      this.endTime = this.historyInfo.endTime
      this.pageMo = this.historyInfo.pageMo
      this.limitMo = this.historyInfo.limitMo
    },

    // 新增提交
    preservationAdd(formName) {
      let $this = this
      let url = !$this.paramFrom.ormtb602id
        ? '/ormtb602/add'
        : '/ormtb602/update'
      this.$refs[formName].validate(valid => {
        if (valid) {
          var loading = this.$loading({
            lock: true,
            text: '请求中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)',
          })
          let postData = $this.paramFrom

          $this.axios
            .post(url, postData)
            .then(res => {
              if (res.data.code == 200) {
                $this.$message({
                  message: !$this.paramFrom.ormtb602id
                    ? '新增成功'
                    : '修改成功',
                  type: 'success',
                })
                $this.$refs[formName].resetFields()
                $this.pageList()
                $this.cdsUpdateShow = false
              } else {
                $this.$message({
                  message: res.data.message,
                  type: 'error',
                })
              }
              setTimeout(() => {
                loading.close()
              }, 300)
            })
            .catch(() => {
              loading.close()
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 查询
    queryClick() {
      this.pageMo = 1
      this.tableData = []
      this.pageList()
    },
    // 列表
    pageList() {
      var loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        // startTime: this.startTime, //开始时间
        // endTime: this.endTime, //结束时间
        // ORMTB473CA00: this.ORMTB473CA00,
        page: this.pageMo,
        limit: this.limitMo,
        ORMTB601ID: this.ORMTB601ID,
        ORMTB602CA00: this.ORMTB602CA00,//桩编号
        ORMTB602CA03: this.ORMTB602CA03, //桩名称
        ORMTB607CA12: this.ORMTB607CA12, //车牌号
        ORMTB607CA14: this.ORMTB607CA14,
        ORMTB607CA10: this.ORMTB607CA10,
        ORMTB410ID: this.ORMTB410ID,
        startTime: this.dateTime1 ? this.dateTime1[0] : '',
        endTime: this.dateTime1 ? this.dateTime1[1] : '',
      }

      var url = '/orm/ormtb607/selectPageList'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)

          if (res.data.code == 200) {
            var data = res.data.data.list
            this.pagingPageMo = res.data.data.total
            let array = [
              {
                label: '总金额',
                value: res.data.data.totalAmount + '元',
              },
              {
                label: '总时长',
                value: res.data.data.totalDuration + '分钟',
              },
              {
                label: '电费金额',
                value: res.data.data.totalDf || 0 + '元',
              },
              {
                label: '服务费金额',
                value: res.data.data.totalFWF || 0 + '元',
              },
              {
                label: '总电量',
                value: res.data.data.totalBattery + '度',
              },
            ]
            this.statusList = array
            this.tableData = data
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    // 详情
    DetailsClick(row) {
      let tabList = this.$store.state.tablist
      const tabIndex = tabList.findIndex(
        item => item.PERTB001CA05 === 'Home:chargingOrderDetails'
      )
      if (tabIndex !== -1) {
        tabList.splice(tabIndex, 1) //移除已存在订单详情
      }
      let path = `/Home/chargingOrderDetails?id=${row.ORMTB607ID}`
      let resitem = {
        PERTB001CA00: '订单详情',
        PERTB001CA03: `${path}`,
        PERTB001CA04: '1',
        PERTB001CA05: 'Home:chargingOrderDetails',
        PERTB001CB00: 'ALL',
      }

      var str = JSON.stringify(tabList)
      var index = str.indexOf('/Home/bridgeDetails')
      if (index == -1) {
        var Stablsit = this.$store.state.tablist.slice()
        Stablsit.push(resitem)
        this.$store.commit('upEditableTabs', Stablsit)
      }
      this.$store.commit('setHistTabsValue', path)
      this.$router.push(this.$store.state.setHistTabsValue)
      // this.$router
      //   .push({
      //     name: 'bridgeDetails',
      //     query: {
      //       ormtb602id: JSON.stringify(row),
      //     },
      //   })
      //   .catch(err => {
      //     console.error('路由跳转错误:', err)

      //   })
    },

    modify(row) {
      this.paramFrom = JSON.parse(JSON.stringify(row))
      this.cdsUpdateShow = true
    },

    cduserClick(row) {
      this.cdsUpdateShow = true
      this.paramFrom = {
        ormtb601id: '',
        ormtb602ca00: '',
        ormtb602ca0: '',
        ormtb602ca03: '',
        ormtb602ca04: 100,
        ormtb602ca05: 1,
        ormtb602ca06: '',
        ormtb602ca09: 1,
        ormtb602ca10: '',
      }
    },

    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.pageList()
    },
  },
}
</script>

<style scoped>
.top_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
  padding: 4px 0 8px;
}
.title {
  position: relative;
  padding-left: 12px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #183b5b;
}
.title::before {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 0;
  width: 4px;
  border-radius: 4px;
  content: '';
  background: #199fff;
}
.right_btns {
  display: flex;
}
.dc_btn {
  border-radius: 8px;
  background: #ff9f1a !important;
  color: #fff !important;
  border: 1px solid #ff9f1a !important;
  height: 32px;
  margin-left: 15px;
  font-size: 16px;
  width: 75px;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
  padding: 0 !important;
}
.dc_btn i,
.dc_btn span {
  color: #fff !important;
}
.right_btns .right_btns_item {
  text-align: center;
  width: 174px;
  height: 32px;
  border: 1px solid #199fff;
  border-radius: 8px;
  line-height: 32px;
  background: #199fff;
  font-size: 16px;

  margin-right: 15px;
}

.from_item {
  display: flex;
}
::v-deep .from_item .el-form-item__label {
  width: 120px !important;
}
::v-deep .searchfrom_item .el-form-item__label {
  width: 100px !important;
  margin-left: 20px;
}
::v-deep .searchfrom_item .el-form-item__content {
  width: 60%;
}
::v-deep .from_item .el-form-item__content {
  width: 90%;
}
::v-deep .el-table .has-gutter tr {
  background: #199fff !important;
}

::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper th,
::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper tr,
::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper .el-table__cell {
  color: #fff !important;
  background: #199fff !important;
  font-weight: bold;
}

::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper .cell {
  color: #fff !important;
}

::v-deep .el-dialog__body {
  padding-top: 3px;
}
::v-deep .el-divider--horizontal {
  margin-top: 10px;
}
.pulbic_oparetionBlock {
  text-align: left;
}
.search_btns {
  float: right;
}
.sub_btns {
  float: right;
  margin-top: 20px;
}
</style>
